<template>
    <div id="login" class="container">
        <div class="columns is-mobile">
            <div class="column is-10-mobile is-offset-1-mobile is-4-tablet is-offset-4-desktop">
                <div class="columns wrapper">
                    <div class="column is-12">
                        <div id="logo">
                            <img src="/images/dashboard/pasti-logo-big.svg">
                        </div>
                        <div class="title is-5 has-text-centered">
                            Login
                        </div>

                        <form id="login-form" data-vv-scope="login-form" @submit.prevent="validateLoginForm('login-form')">
                            <div class="columns">
                                <div class="column is-10 is-offset-1-tablet">
                                    <!-- Display success message -->
                                    <div class="notification is-success" v-if="success_message">
                                        <button class="delete" @click="success_message = ''"></button>
                                        <p>{{ success_message }}</p>
                                    </div>

                                    <!-- Display error message -->
                                    <div class="notification is-danger" v-if="error_message">
                                        <button class="delete" @click="error_message = ''"></button>
                                        <p v-if="error_message.constructor !== Array">{{ error_message }}</p>
                                        <div class="content" v-else>
                                            <ul>
                                                <li v-for="(error, index) in error_message">{{ error }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Username text input -->
                            <div class="columns">
                                <div class="column is-10 is-offset-1-tablet">
                                    <div class="field">
                                        <p class="control has-icons-right">
                                            <input v-model="email" v-validate="'required'" class="input" type="text"
                                                   name="email" placeholder="Email" data-vv-as="email">

                                            <span v-show="errors.has('login-form.email')" class="icon is-small is-right">
                                              <i class="fa fa-warning"></i>
                                            </span>
                                        </p>

                                        <span class="help is-danger" v-show="errors.has('login-form.email')">{{ errors.first('login-form.email') }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Password text input -->
                            <div class="columns">
                                <div class="column is-10 is-offset-1-tablet">
                                    <div class="field">
                                        <p class="control has-icons-right">
                                            <input v-model="password" v-validate="'required'" class="input" type="password"
                                                   name="password" placeholder="Password" data-vv-as="password">

                                            <span v-show="errors.has('password')" class="icon is-small is-right">
                                              <i class="fa fa-warning"></i>
                                            </span>
                                        </p>

                                        <span class="help is-danger" v-show="errors.has('login-form.password')">{{ errors.first('login-form.password') }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Sign In button -->
                            <div class="columns">
                                <div class="column is-10 is-offset-1-tablet has-text-centered">
                                    <button type="submit" class="button submit-button title is-6" :class="{'is-loading': isLoading}" :disabled="isLoading">
                                        Sign In
                                    </button>
                                </div>
                            </div>
                        </form>

                        <!-- Forgot Password -->
                        <div class="columns">
                            <div class="column is-10 is-offset-1-tablet has-text-centered">
                                <div class="forgot-password title is-6">
                                    <a :href="this.forgot_password_url">Forgot password?</a>
                                </div>
                            </div>
                        </div>

                        <!-- Google Play Badge -->
                        <div class="columns is-mobile download-app">
                            <div class="column is-6 is-offset-3">
                                <div class="columns is-mobile">
                                    <div class="column is-4">
                                        <p>Download our app</p>
                                    </div>
                                    <div class="column is-8">
                                        <a href="https://play.google.com/store/apps/details?id=my.com.myeg.pasti" target="_blank">
                                            <img src="/images/dashboard/google-play-badge.png" class="img-responsive">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Copyright -->
                        <div class="columns">
                            <div class="column is-12">
                                <div class="copyright has-text-centered">
                                    Copyright {{ current_year }}  MyEG Servics Berhad. All Rights Reserved. Version 1.1
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const moment = require('moment');

    export default {
        props: {
          login_url: {
              type: String,
              required: true
          },
            forgot_password_url: {
                type: String,
                required: true
            },
            dashboard_url: {
                type: String,
                required: true
            }
        },
        data: function() {
            return {
                success_message: '',
                error_message: '',
                email: '',
                password: '',
                isLoading: false,
            }
        },
        methods: {
            validateLoginForm(scope) {
                this.$validator.validateAll(scope).then((result) => {
                    if (result) {
                        this.login();
                    }
                });
            },
            login: function()
            {
                this.isLoading = true;
                let postData = {
                    email: this.email,
                    password: this.password,
                };

                axios.post(this.login_url, postData)
                    .then(response => {
                        let vm = this;
                        if (response.data.message !== undefined) {
                            // Add a cache-busting query parameter to the URL to ensure a fresh page load.
                            window.location.href = this.dashboard_url + '?t=' + new Date().getTime();
                            return;
                        }

                        if (response.data.error !== undefined) {
                            vm.error_message = response.data.error;
                        }
                    })
                    .then(() => {
                        this.errors.clear();
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        if (error.response !== undefined) {
                            // Display validation error messages.
                            if (error.response.status === 422) {
                                let errorMessage = [];

                                Object.values(error.response.data.errors).forEach(function (item, key) {
                                    errorMessage.push(item[0]);
                                });

                                this.error_message = errorMessage;
                            }

                            // Too many login attempts error
                            if (error.response.status == 429) {
                                this.error_message = error.response.data.error
                            }
                        }
                    })
            }
        },
        computed: {
            moment: function() {
                return moment;
            },
            current_year: function() {
                return moment().utcOffset('+0800').year();
            }
        }
    }
</script>
